import { createTheme } from "@mui/material/styles";

// A custom theme for this app
const theme = createTheme({
  typography: {
    fontFamily: "Inter, san-serif",
  },
  palette: {
    text: { primary: "#1F1F1F", secondary: "#808080" },
    primary: {
      main: "#255CCE",
    },
    secondary: {
      main: "#fff",
    },
    error: {
      main: "#B00020",
    },
  },
});

export default theme;
